import { UserSettings } from 'src/app/core/models/i-user-settings';

export interface ISaveUserSettingsRequest {
  settings: UserSettings;
  user: string;
}
export class SaveUserSettingsRequest implements ISaveUserSettingsRequest {
  constructor(
    public settings: UserSettings,
    public user: string,
  ) {}
}
